declare var require: any;

export const environment = {
  production: true,
  apiBaseUrl: 'https://rentlzuat.moveinsync.com/',
  version: require('../../package.json').version,
  razorPayApiKey: 'rzp_test_MlQTugy7uh4TR7',
  raygunEnabled: false,
  contextEnv: 'uat'
};
